import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, CheckCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si no sé nada de tecnología?',
    a: 'Absolutamente. Si sabés usar Facebook, podés seguir nuestra guía. No necesitás escribir ni una línea de código.'
  }, {
    q: '¿Meta me puede bloquear el número?',
    a: 'Usamos la API oficial (Bonus 2), la forma legal y segura que Meta aprueba para automatizar. Cero riesgo de baneos.'
  }, {
    q: '¿Es muy caro mantener la IA?',
    a: 'No. Te enseñamos a usar herramientas que cuestan centavos por mensaje. Pagás solo por lo que usás, infinitamente más barato que un empleado.'
  }];
  return <section className="py-14 px-4 bg-[#0a0a0a]" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-4">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-6" data-id="element-5">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111] p-6 rounded-2xl border border-white/5" data-id="element-6">
              <h3 className="text-xl font-bold text-white mb-3 flex items-start gap-3" data-id="element-7">
                <HelpCircle className="w-6 h-6 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-8" />
                {faq.q}
              </h3>
              <p className="text-gray-400 flex items-start gap-3 pl-9" data-id="element-9">
                <CheckCircle className="w-5 h-5 text-[#25D366] flex-shrink-0 mt-0.5" data-id="element-10" />
                {faq.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}